// extracted by mini-css-extract-plugin
export var labelWrapper = "_gy-0";